import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViewOff = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.95898 16.1459L17.2819 3.02087",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.68066 14.7247C8.43143 14.9473 9.21372 15.0577 9.99983 15.0521C13.1318 15.1024 16.308 13.001 18.2682 10.9418C18.4783 10.7191 18.5946 10.43 18.5946 10.1302C18.5946 9.83049 18.4783 9.54137 18.2682 9.31866C17.5581 8.57507 16.7714 7.90157 15.92 7.30835",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8432 5.414C11.2405 5.27083 10.6211 5.20172 9.99997 5.20837C6.92073 5.15952 3.73608 7.21504 1.73393 9.31723C1.52377 9.53994 1.40747 9.82905 1.40747 10.1288C1.40747 10.4285 1.52377 10.7176 1.73393 10.9404C2.34269 11.5765 3.00713 12.1619 3.72004 12.6904",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.13525 10.1302C7.13515 9.77114 7.20918 9.41553 7.3531 9.08374C7.49703 8.75194 7.70803 8.45047 7.97405 8.19654C8.24007 7.94261 8.5559 7.7412 8.90349 7.60382C9.25108 7.46644 9.62363 7.39578 9.99984 7.39587",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8646 10.1295C12.8647 10.4887 12.7907 10.8443 12.6467 11.1761C12.5028 11.508 12.2918 11.8095 12.0258 12.0635C11.7598 12.3175 11.444 12.5189 11.0964 12.6564C10.7488 12.7939 10.3762 12.8646 10 12.8646",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgViewOff);
export default ForwardRef;
